import { typography } from "./typography";
import { spacing } from "./spacing";
import { shadow } from "./shadow";

export const SAVORY_THEME = {
    typography,
    spacing,
    shadow,
    colors: {
        neutral: {
            50: "#F3F3F3",
            100: "#E8E8E8",
            200: "#D1D1D1",
            300: "#BABABA",
            400: "#A3A3A3",
            500: "#8C8C8C",
            600: "#767676",
            700: "#5F5F5F",
            800: "#484848",
            900: "#1A1A1A",
        },
        primary: {
            50: "#F2F7FF",
            100: "#DCEBFE",
            200: "#BEDBFE",
            300: "#91C3FD",
            400: "#61A6FA",
            500: "#3479E9",
            600: "#2463EB",
            700: "#1D4FD7",
            800: "#1E3FAE",
            900: "#1E3B8A",
        },
        secondary: {
            50: "#FDFDFD",
            100: "#F4F4F5",
            200: "#E4E4E7",
            300: "#D4D4D8",
            400: "#A1A1AA",
            500: "#71717A",
            600: "#52525B",
            700: "#3F3F46",
            800: "#27272A",
            900: "#18181B",
        },
        success: {
            50: "#F2FDF5",
            100: "#DEFCE9",
            200: "#BBF7D0",
            300: "#85EFAC",
            400: "#4ADE80",
            500: "#1AC057",
            600: "#16A249",
            700: "#157F3C",
            800: "#1C713C",
            900: "#114C29",
        },
        warning: {
            50: "#FEFCE7",
            100: "#FEF9C3",
            200: "#FEF08B",
            300: "#FDDF49",
            400: "#FACC14",
            500: "#E7B008",
            600: "#C78904",
            700: "#A26107",
            800: "#864E0E",
            900: "#733F12",
        },
        destructive: {
            50: "#FEF1F1",
            100: "#FEE1E1",
            200: "#FEC8C8",
            300: "#FCA6A6",
            400: "#FD6B6B",
            500: "#EF4343",
            600: "#DC2828",
            700: "#BA1C1C",
            800: "#981B1B",
            900: "#811D1D",
        },
        info: {
            50: "#F0F9FF",
            100: "#E1F3FE",
            200: "#BAE5FD",
            300: "#7ED4FC",
            400: "#3ABFF8",
            500: "#0DA2E7",
            600: "#0284C5",
            700: "#0369A0",
            800: "#075783",
            900: "#0C4A6E",
        },
        orange: {
            50: "#FFF6EB",
            100: "#FFEDD6",
            200: "#FED6A9",
            300: "#FDBA72",
            400: "#FB923C",
            500: "#F67416",
            600: "#E9590C",
            700: "#C03F0C",
            800: "#9B3B12",
            900: "#7D2D12",
        },
    },
};

export type Theme = typeof SAVORY_THEME;
